<template>
    <div>
        <b-alert
            v-model="successSecs"
            dismissible
            variant="success"
            @dismissed="successCountDown=0"
            @close-countdown="successCountDown = $event"
        >
            <p>{{ $t('The scanresult will be copied in') }}  3 {{$t('seconds...')}}</p>
            <b-progress variant="success" :max="successSecs" :value="successCountDown" height="4px" />
        </b-alert>
        <label for="qrtextarea">{{ $t('Last result') }}:</label>
        <b-form-textarea
            id="qrtextarea"
            v-model="result"
            :placeholder="$t('scan something...')"
            rows="2"
            max-rows="6"
        ></b-form-textarea>
        <div v-if="!isValid" class="validation-failure">
            the scanned key is not valid!
        </div>
        <qrcode-stream @error="onError"
                       @detect="onDetect"
                       :paused="paused"
                       :constraints="{ facingMode }">
            <div v-show="showScanConfirmation" class="scan-confirmation">
                <img src="/img/icons8-scan-64.png" alt="Checkmark" width="128px" />
            </div>
        </qrcode-stream>
    </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
    name: "QrcodeScanner",
    components: { QrcodeStream },

    data () {
        return {
            result: null,
            isValid: true,
            showScanConfirmation: false,
            successSecs: 3000,
            successCountDown: 0,
            showDismissibleAlert: false,
            facingMode: 'environment',
            paused: false
        }
    },

    methods: {

        onDetect: function(content){
            const resultObject = content[0];
            this.result =  content[0].rawValue ?? '';
            this.isValid = this.result.length === 160
            this.pause()
            if(this.isValid){
                this.showAlert()
                setTimeout(this.send, 3500)
            } else{
                setTimeout(this.unpause, 1000)
            }

        },
        onError: function(error){
         // console.log(error);
            console.log('errorCamera');
        },

        send(){
            this.$emit('qrevent', this.result);
        },

        unpause () {
            this.paused = false;
        },

        pause () {
            this.paused = true;
        },

        countDownChanged(successCountDown) {
            this.successCountDown = successCountDown
        },

        showAlert() {
            this.showDismissibleAlert = true;
            this.showScanConfirmation = true;
            this.successSecs = this.successSecs + 1000;
           // this.successCountDown = this.successSecs
        },

        timeout (ms) {
            return new Promise(resolve => {
                window.setTimeout(resolve, ms)
            })
        }
    }
}
</script>

<style scoped>

.validation-success {
    color: green;
}
.validation-failure {
    color: red;
}

.scan-confirmation {
    position: absolute;
    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, .8);

    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}
</style>
